/*
 * @Author:
 * @Description:
 * @Date: 2025-06-05 19:55:45
 * @LastEditors: Please set LastEditors
 * @FilePath: /rhcn-merchant-web/src/language/networkApplication/en.js
 */
export default {
  networkApplication: {
    title: 'Network Application',
    validateBusiness: 'Validate Business',
    companyDetails: {
      title: 'Business Details',
      descript1: 'Business Details',
      descript2: 'Onerway collects this information to better understand and serve your business.',
      legalBusinessName: 'Entity Legal Name',
      tradingName: 'Trading Name/Used Name',
      registrationNumber: 'Business Registration Number',
      registrationDate: 'Date of Incorporation',
      registrationAddress: 'Registered Address',
      location: 'Country/Region',
      areaOrCity: 'City/Area',
      district: 'District',
      streetAddress: 'Street',
      detailedAddress: 'Detailed address',
      postalCode: 'Postal code',
      businessType: 'Business Entity Type',
      operatingAddress: 'Business Operating Address',
      selectCountry: 'Please select country/region',
      corporateEmail: 'Corporate Email Address',
      corporatePhone: 'Corporate Phone Number',
      wechat: 'WeChat',
      skype: 'Skype',
      uploadCertificates: 'Corporate Documentation',
      uploadLimit: 'Upload Limit',
      continue: 'Continue',
      inputError: 'Please enter valid characters',
      emailError: 'Please enter a valid email address',
      phoneError: 'Please enter a valid phone number',
      required: 'Required',
      certificate_of_incorporation: 'Certificate of Incorporation',
      business_registration_certificate: 'Business Registration Certificate',
      form_NNC1_NAR1: 'Form NNC1/NAR1',
      form_IN01: 'Form IN01',
      // 公司更名证明
      certificate_of_change_name: 'Certificate of Change of Name',
      // 办公地址证明
      proof_of_address: 'Proof of Address',
      // 股权架构说明
      proof_of_shareholding_structure: 'Proof of Shareholding Structure',
    },
    companyOwner: {
      title: 'Business Owners',
      descript1: 'Business Owners',
      descript2: 'We\'re required to collect information on anyone who has significant ownership (25% or more) of your business.',
      owner: 'Owner',
      delete: 'Delete',
      name: 'Full Legal Name',
      namePlaceholder: 'Please enter legal name',
      type: 'Position/Relationship',
      typePlaceholder: 'Please select owner type',
      birthDate: 'Date of Birth',
      birthDatePlaceholder: 'Please select date of birth',
      communicationAddress: 'Residential Address',
      location: 'Country/Region',
      locationPlaceholder: 'Please select country',
      areaOrCity: 'City/Area',
      areaOrCityPlaceholder: 'City/Area',
      district: 'District',
      districtPlaceholder: 'District',
      streetAddress: 'Street',
      streetAddressPlaceholder: 'Street',
      detailedAddress: 'Detailed address',
      detailedAddressPlaceholder: 'Detailed address',
      postalCode: 'Postal code',
      postalCodePlaceholder: 'Please enter postal code',
      idIssuingCountry: 'ID Issuing Country/Region',
      idIssuingCountryPlaceholder: 'Please select ID issuing country/region',
      idType: 'Identification Type',
      idTypePlaceholder: 'Please select ID type',
      idNumber: 'Identification Number',
      idNumberPlaceholder: 'Please enter ID number',
      shareholding: 'Shareholding Percentage',
      shareholdingPlaceholder: 'Please enter shareholding percentage',
      uploadDocuments: 'Identity Documentation',
      addOwner: 'Add Owner',
      continue: 'Continue',
      inputError: 'Please enter valid characters',
      required: 'Required',
      identificationDocumentFront: 'Government-Issued Identification Document Front Side (Photo Side)',
      identificationDocumentBack: 'Government-Issued Identification Document Back Side',
      proofOfAddress: 'Proof of Address',
      lastPositionOrRelationshipName: 'Position/Relationship',
      idIssuingCountryOrRegion: 'ID Issuing Country/Region',
      identificationType: 'Identification Type',
      identificationNumber: 'Identification Number',
      shareholdingPercentage: 'Shareholding Percentage',
      director: 'Director',
      legalRepresentative: 'Legal Representative',
      ultimateBeneficialOwner: 'Ultimate Beneficial Owner (UBO)',
      proxyActionPerson: 'Person Purporting to Act (PPTA)',
      idType_idCard: 'ID Card',
      driverLicense: 'Driver License',
      passport: 'Passport',
      // 删除确认相关
      deleteConfirmTitle: 'Confirm Delete',
      deleteConfirmContent: 'Are you sure you want to delete this business owner? ',
      deleteSuccessMessage: 'Business owner deleted successfully',
    },
    payoutBusinessInfo: {
      title: 'Website/App Details',
      descript1: 'Website/App Details',
      descript2: 'Onerway collects this information to better understand and serve your business.',
      websiteUrl: 'Website URL',
      operationalHistory: 'Operational History',
      platformType: 'Platform Type',
      primaryDomain: 'Primary Domain',
      primaryDomainPlaceholder: 'Please enter primary domain',
      merchantCategory: 'Merchant Category',
      merchantCategoryPlaceholder: 'Please select merchant category',
      monthlyTransactionAmount: 'Monthly Transaction Amount (USD)',
      averageTransactionAmount: 'Average Transaction Amount (USD)',
      chargebackRatio: 'Chargeback Ratio',
      refundRatio: 'Refund Ratio',
      targetMarkets: 'Target Markets',
      businessVerificationDocuments: 'Business Verification Documents',
      website: 'Website URL',
      appName: 'App Name',
      appDescription: 'App Description',
      businessType: 'Business Type',
      continue: 'Continue',
      inputError: 'Please enter valid characters',
      required: 'This field is required',
      average_transaction_amount: 'Average Transaction Amount',
      monthly_trading_volume: 'Monthly Trading Volume',
      monthly_dispute_rate: 'Monthly Dispute Rate',
      monthly_refund_rate: 'Monthly Refund Rate',
      market: 'Market',
      uploadBusinessProofs: 'Upload Business Proofs',
      hottest: 'Hottest Industry',
      otherMarket: 'Other Industry',
      // 办公室照片（需体现主体名称）
      officePhotos: 'Office Photos (must show the business name)',
      // 仓库货品存货照片
      warehouseInventoryPhotos: 'Warehouse Inventory Photos (mandatory for physical e-commerce)',
      // 近6个月的历史交易表格
      transactionTableForTheLast6Months: 'Transaction Table for the Last 6 Months',
      // 原始交易数据
      originalTransactionData: 'Original Transaction Data',
    },
    bankAccount: {
      title: 'Bank Account',
      descript1: 'Bank Account',
      descript2: 'Add your bank to receive payouts. A payout is the transfer of funds from Onerway to your bank account.',
      accountHolderName: 'Account Holder Name',
      accountHolderNamePlaceholder: 'Must be the same as the legal company name',
      chooseYourBank: 'Choose Your Bank',
      bankBranchAddress: 'Bank Branch Address',
      bankingAccountVerificationDocuments: 'Banking Account Verification Documents',
      bankAddress: 'Bank Address',
      bankAddressPlaceholder: 'Search your bank/ SWIFT Code',
      registeredAddress: 'Registered Address',
      location: 'Location',
      locationPlaceholder: '',
      areaOrCity: 'City/Area',
      areaOrCityPlaceholder: 'city/area',
      district: 'District/County',
      districtPlaceholder: 'district/county',
      streetAddress: 'Street Address',
      streetAddressPlaceholder: 'street address',
      detailedAddress: 'Detailed Address',
      detailedAddressPlaceholder: 'detailed address',
      postalCode: 'Postal Code',
      postalCodePlaceholder: 'postal code',
      settlementCurrency: 'Settlement Currency',
      settlementCurrencyPlaceholder: 'Please select currency',
      accountNumber: 'Account Number',
      accountNumberPlaceholder: 'Please enter account number',
      confirmAccountNumber: 'Confirm Account Number',
      confirmAccountNumberPlaceholder: 'Please confirm account number',
      uploadDocuments: 'Upload Documents',
      continue: 'Continue',
      inputError: 'Please enter valid characters',
      required: 'This field is required',
      atLeast3SwiftCodeTips: 'Please enter at least 3 characters of SWIFT code',
      noDataText: 'No data available',
      proofOfBankAccount: 'Proof of Bank Account',
      bankStatements: 'Bank Statements',
      confirmAccountNumber_label_GB: 'Confirm IBAN',
    },
    status: {
      title: 'Review and Confirm',
      content: '', // Please check and submit your applications
      companyType: 'Company Type',
      companyDetails: 'Company Details',
      companyRepresentative: 'Company Representative',
      companyOwner: 'Company Owner',
      websiteOrApplication: 'Website/Application',
      bankAccount: 'Bank Account',
      edit: 'Edit',
      submitAgreementTips: 'By clicking "Submit Application", you agree to our <a href="#" target="_blank">Terms of Service</a> and <a href="#" target="_blank">Privacy Policy</a>.',
      submitAgreement: 'Submit Application',
      applicationSubmitted: 'Application Submitted',
      applicationSubmittedContent: 'Your application has been submitted successfully.',
      applicationSubmittedTips: 'We will review your application and contact you within 1-2 business days.',
      required: 'Required',
      warning: 'Warning',
    },
    saveSuccess: 'Saved successfully',
    submitSuccess: 'Submitted successfully',
    paymentMethods: {
      visa: 'Visa',
      mastercard: 'Mastercard',
    },
    approveStatus: {
      waiting: 'PENDING REVIEW',
      processing: 'UNDER REVIEW',
      pass: 'APPROVED',
      fail: 'REJECTED',
      cancel: 'Cancel/Revoke',
      unnecessary: 'No Need',
      refuse: 'REJECTED',
      suspend: 'Suspend', // 挂起
      status: 'Approval Status',
      orderNumber: 'Order Number',
      merchantNo: 'Merchant No',
      merchantName: 'Merchant Name',
      approveComments: 'Approve Comments',
    },
    guideForCooperate: {
      title: 'Welcome to Onerway\'s Payment Service',
      introText: 'Before you start filling out your information, we want to ensure you understand our pricing structure and the next steps in our partnership process.',
      pricing: {
        title: 'Pricing',
        processingFee: {
          title: 'Processing fee',
          value: '$ 0.30',
          desc: 'Refund fee, dispute fee, etc. are not included.',
        },
        merchantFee: {
          title: 'Merchant Discount Rate',
          value: 'Interchange++0.50%',
          desc: 'Includes the Interchange and Scheme fees from card networks. ONERWAY applies an additional service fee of 0.50%.',
        },
      },
      process: {
        title: 'Process:',
        steps: {
          fillInfo: 'Fill Out Information',
          review: 'Review',
          signContract: 'Contract Signing',
          systemConfig: 'System Configuration',
          startUse: 'Start Using',
        },
      },
      agreement: 'By clicking "Continue" button, you agree to the above information.',
      continue: 'Continue',
    },
    extraDocument: {
      extraDocument1: 'Other Document 1',
      extraDocument2: 'Other Document 2',
      extraDocument3: 'Other Document 3',
      extraDocument4: 'Other Document 4',
      extraDocument5: 'Other Document 5',
      extraDocument6: 'Other Document 6',
      extraDocument7: 'Other Document 7',
      extraDocument8: 'Other Document 8',
      extraDocument9: 'Other Document 9',
      extraDocument10: 'Other Document 10',
    },
    validateError: {
      // 仅支持英文字母、阿拉伯数字、空格
      onlySupportEnglishLettersAndNumbersAndSpaces: 'Only support English letters, numbers, and spaces',
      // 两次输入的银行账户不一致
      confirmAccountNumberNotMatch: 'The two entered bank accounts do not match',
    },
  },
};
